export class QualityType {
    id: string;
    name: string;
    explanation: string | null;

    constructor(id: string, name: string, explanation: string | null = null) {
        this.id = id;
        this.name = name;
        this.explanation = explanation;
    }
}

export class Competention {
    id: string;
    description: string;
    qualityTypeIds: string[];
    examOrder: number;
    employerDescription: string;

    constructor(
        id: string,
        description: string,
        qualityTypeIds: string[],
        examOrder: number,
        employerDescription: string,
    ) {
        this.id = id;
        this.description = description;
        this.qualityTypeIds = qualityTypeIds;
        this.examOrder = examOrder;
        this.employerDescription = employerDescription;
    }
}

export class CostCentre {
    id: string;
    name: string;
    companyId: string;

    constructor(id: string, name: string, companyId: string) {
        this.id = id;
        this.name = name;
        this.companyId = companyId;
    }
}

export class BusinessLine {
    id: string;
    name: string;

    constructor(id: string, name: string) {
        this.id = id;
        this.name = name;
    }
}

export class RateComponentSet {
    id: string;
    name: string;
    isDefault: boolean;

    constructor(id: string, name: string, isDefault: boolean) {
        this.id = id;
        this.name = name;
        this.isDefault = isDefault;
    }
}

export enum UserType {
    Employee = 0,
    Employer = 1,
}

export enum EmployeeType {
    Employee = 0,
    Freelancer = 1,
    FixedEmployee = 2,
}

export enum RequestRegistrationStatus {
    Pending = 0,
    Denied = 1,
    Accepted = 2,
    PendingReserve = 4,
    DeniedReserve = 5,
    AcceptedReserve = 6,
}
export enum ClockStatus {
    Finished = 0,
    NoShow = 1,
}

export enum RegistrationStatusIndicatorType {
    AddedToGroupApp = 0,
    BriefingShared = 1,
    BriefingRead = 2,
}

export enum RegistrationProcessStatus {
    PendingApproval = 0,
    ReadyForProcessing = 1,
    Processed = 2,
}

export enum RequestApplicationProvider {
    Vermaat = 0,
    Fleks = 1,
    Felix = 2,
}

export enum AttachmentType {
    Map = 1,
    Briefing = 2,
    Other = 3,
}
